import React,{ useRef, useState } from 'react'
import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';
import { 
    GuestListTableContainer, 
} from './communication.style';
import {useHistory } from 'react-router-dom';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; 
import { AppInputField, AppInputFieldBtn } from '../../../../widget/styledComponents/input_field.style';
import { gql, useMutation } from '@apollo/client';
import Cookies from 'js-cookie';
import { Heading, Spinner, Tab, TabNavigation, toaster } from 'evergreen-ui';
import ImageUpload from './image_uploader';
import DocumentUpload from './document_uploader';

export const ADD_COMMUNICATION = gql`
mutation Communication_create($facilityId: ID!, $title: String!, $body: String!, $image: String!, $docs: [String!]!, $type: CommunicationType!) {
    communication_create(facilityId: $facilityId, title: $title, body: $body, image: $image, docs: $docs, type: $type) {
    code
    success
    error
    data {
      _id
      title
      body
      type
      author {
        name
        email
      }
      hasBeenRead
      createdAt
      image
      docs
      facility
      authorType
      id
      admin
      facilityManager
    }
  }
}

`;




function AddCommPageWidget() {
const handleChange = (html) => {
setEditorHtml(html);
};
const tabs = React.useMemo(() => ['Announcement',], [])
const [selectedTypeIndex, setSelectedTypeIndex] = React.useState()
const facilityId = Cookies.get('facilityId');
const [editorHtml, setEditorHtml] = useState('');
const postTitledRef = useRef(null);
const [addCommunication,{ loading }]  = useMutation(ADD_COMMUNICATION);
const history = useHistory()
const handleSubmit=(e)=>{
    e.preventDefault()
    const ddateToSend ={
        facilityId:facilityId,
        title:postTitledRef.current.value,
        body:editorHtml,
        type:'Announcement',
        image:uploadedImageUrl,
        docs:uploadedDocumentUrls
    };
    addCommunication({
        variables: ddateToSend,
    })
    .then((response) => {
      toaster.success("Post added")
      history.push(`/communication`);
    window.location.reload()
    })
    .catch((error) => {
      toaster.danger(error.message)
    });
  }

  const [uploadedImageUrl, setUploadedImageUrl] = useState(null);
  const [uploadedDocumentUrls, setUploadedDocumentUrls] = useState([]);

  // Handle the uploaded URL
  const handleUploadComplete = (url) => {
    setUploadedImageUrl(url);
    console.log("Uploaded Image URL:", url);
  }


  // Handle the uploaded document URLs
  const handleUploadComplete2 = (urls) => {
    setUploadedDocumentUrls(urls);
    console.log("Uploaded Document URLs:", urls);
  };


  return (
    <div className=''>

        <br/>
       
        <div className='row'>
            <div className='col s12 m3'>
                <PageTitleText>
                    Communication - Add post
                </PageTitleText>
            </div>
            
        </div>  
        <form onSubmit={handleSubmit}>
        <GuestListTableContainer>
        <Heading size={600} marginTop={28}>
            Pick communication type
        </Heading>
            <TabNavigation className='z-depth-0 transparent'>
                {tabs.map((tab, index) => {
                    return (
                    <Tab
                        is="a"
                        isSelected={selectedTypeIndex === index}
                        key={tab}
                        onClick={() => setSelectedTypeIndex(tab)}
                    >
                        {tab}
                    </Tab>
                    )
                })}
            </TabNavigation>


            <Heading size={600} marginTop={28}>
                Title
            </Heading>
            <AppInputField
                type="text" 
                ref={postTitledRef}
                required
            /> 

            <Heading size={600} marginTop={28}>
                Body
            </Heading>
            <div>
                <ReactQuill
                    theme="snow" // You can customize the theme here
                    // value={editorHtml}
                    onChange={handleChange}
                    placeholder='Type in your post here'
                    required
                />
                {/* Display the HTML content below the editor */}
                {/* <div dangerouslySetInnerHTML={{ __html: editorHtml }} /> */}
            </div>

            <Heading size={600} marginTop={28}>
                Add image banner
            </Heading>
            <ImageUpload onUploadComplete={handleUploadComplete} />

            <Heading size={600} marginTop={28}>
            Add Document
            </Heading>
            <DocumentUpload onUploadComplete={handleUploadComplete2} />
           
        </GuestListTableContainer>
        <div className="mt-50" style={{
            width:"150px"
        }} >
             <AppInputFieldBtn 
                disabled={loading}
                type='submit'
            >
                {!loading && 
                    <span>
                         POST
                    </span>
                }
                {loading && <center><Spinner/></center> }
            </AppInputFieldBtn>
        </div>
        

        </form>
       
    </div>
  )
}

export default AddCommPageWidget